/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OriginatingSchemeType } from './OriginatingSchemeType';
import {
    OriginatingSchemeTypeFromJSON,
    OriginatingSchemeTypeFromJSONTyped,
    OriginatingSchemeTypeToJSON,
} from './OriginatingSchemeType';

/**
 * 
 * @export
 * @interface JurisdictionSchemeModel
 */
export interface JurisdictionSchemeModel {
    /**
     * 
     * @type {number}
     * @memberof JurisdictionSchemeModel
     */
    originatingSchemeId?: number;
    /**
     * 
     * @type {string}
     * @memberof JurisdictionSchemeModel
     */
    originatingSchemeName?: string;
    /**
     * 
     * @type {OriginatingSchemeType}
     * @memberof JurisdictionSchemeModel
     */
    originatingSchemeType?: OriginatingSchemeType;
    /**
     * 
     * @type {string}
     * @memberof JurisdictionSchemeModel
     */
    fundType?: string;
    /**
     * 
     * @type {string}
     * @memberof JurisdictionSchemeModel
     */
    fundSubmitValuationReports?: string;
}

/**
 * Check if a given object implements the JurisdictionSchemeModel interface.
 */
export function instanceOfJurisdictionSchemeModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JurisdictionSchemeModelFromJSON(json: any): JurisdictionSchemeModel {
    return JurisdictionSchemeModelFromJSONTyped(json, false);
}

export function JurisdictionSchemeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JurisdictionSchemeModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'originatingSchemeId': !exists(json, 'OriginatingSchemeId') ? undefined : json['OriginatingSchemeId'],
        'originatingSchemeName': !exists(json, 'OriginatingSchemeName') ? undefined : json['OriginatingSchemeName'],
        'originatingSchemeType': !exists(json, 'OriginatingSchemeType') ? undefined : OriginatingSchemeTypeFromJSON(json['OriginatingSchemeType']),
        'fundType': !exists(json, 'FundType') ? undefined : json['FundType'],
        'fundSubmitValuationReports': !exists(json, 'FundSubmitValuationReports') ? undefined : json['FundSubmitValuationReports'],
    };
}

export function JurisdictionSchemeModelToJSON(value?: JurisdictionSchemeModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'OriginatingSchemeId': value.originatingSchemeId,
        'OriginatingSchemeName': value.originatingSchemeName,
        'OriginatingSchemeType': OriginatingSchemeTypeToJSON(value.originatingSchemeType),
        'FundType': value.fundType,
        'FundSubmitValuationReports': value.fundSubmitValuationReports,
    };
}

